import React from 'react';
import SelectFancy from '@atoms/SelectFancy';
import useFunctionalTitleOptions from '@hooks/useFunctionalTitleOptions';

const SelectPersonalResponsibilities = ({ label = "Title Category", ...rest }) => {
    const { isLoading, data, error } = useFunctionalTitleOptions();

    if (error) {
        return null;
    }

    return (
        <SelectFancy label={label} name="functionalTitle" options={data} isLoading={isLoading} {...rest} />
    );
};

export default SelectPersonalResponsibilities;
